import { render, staticRenderFns } from "./axischarts.vue?vue&type=template&id=d04ec34e"
import script from "./axischarts.vue?vue&type=script&lang=js"
export * from "./axischarts.vue?vue&type=script&lang=js"
import style0 from "./axischarts.vue?vue&type=style&index=0&id=d04ec34e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports